<template>
  <div class="metacoBtn metacoWhite" @click="handleClick">
    <Icon fill="#045B9C" name="metacoIcon" width="22" />
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import Icon from '@/components/atoms/Icon';

export default {
  name: 'MetacoSignIn',
  components: {
    Icon,
  },
  methods: {
    ...mapActions(['getCredentials', 'snsAuthRequest']),
    ...mapActions(['openModal', 'closeModal']),
    handleClick() {
      this.openModal({ name: 'MetacoEmailModal' });
    },
  },
};
</script>

<style lang="scss">
.metacoBtn {
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 40px !important;
  width: 40px;
  cursor: pointer;
  margin-left: 16px;
  margin-right: 16px;
}
.metacoWhite {
  border-radius: 100%;
  background-color: white;
}
</style>
